import React from 'react';
import styles from './Partners.module.css';

import solana from './assets/solana.png';
import galxe from './assets/galxe.png';
import gateio from './assets/gate_io.png';
import okx from './assets/okx.png';
import metaplex from './assets/metaplex.png';
import helium from './assets/helium.png';

const Partners = () => {
  const logos = [
    { src: solana, alt: 'Solana' },
    { src: galxe, alt: 'Galxe' },
    { src: gateio, alt: 'Gate.io' },
    { src: okx, alt: 'OKX' },
    { src: helium, alt: 'Helium' },
    { src: metaplex, alt: 'Metaplex' },
  ];

  return (
    <section className={styles.partnersSection}>
      <div className={styles.partnersContainer}>
        <div className={styles.partnersTitle}>
          <span>Trusted by</span>
        </div>
        <div className={styles.gradientMaskLeft}></div>
        <div className={styles.gradientMaskRight}></div>
        
        <div className={styles.partnersTrack}>
          {[...logos, ...logos].map((logo, index) => (
            <div key={index} className={styles.partnerLogo}>
              <img src={logo.src} alt={logo.alt} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Partners;
